
import { forwardRef, useImperativeHandle, useRef } from 'react';
import './MahutiInputText.css'

const MahutiInputText = forwardRef(({
    id, 
    label, 
    error, 
    type = 'text', 
    defaultValue, 
    onChange, 
    required,
    ariaDescribedby,
    ariaInvalid,
    ...props 
}, ref) => {
    const inputRef = useRef(null);

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current?.focus();
        },
        scrollIntoView: (options) => {
            inputRef.current?.scrollIntoView(options);
        }
    }));

    const handleChange = (e) => {
        onChange(e.target.value, id);
    };

    return <div className={`MahutiInputText ${props.error}`}>
        <input 
            ref={inputRef}
            type={type}
            className={`text-mahuti ${error ? 'error' : ''}`}
            id={id}
            defaultValue={defaultValue}
            onChange={handleChange}
            required={required}
            aria-required={required ? "true" : "false"}
            aria-invalid={ariaInvalid || (error ? "true" : "false")}
            aria-describedby={ariaDescribedby}
            {...props}
        />
        <label className={"placeholder-text " + (required ? 'required' : '') } htmlFor={id} id="placeholder-fname" aria-required>
            <div className="text">{label}</div>
        </label>
    </div>


})

MahutiInputText.displayName = 'MahutiInputText';

export default MahutiInputText;